import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconStarWand: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconStarWand"><Path d="M5.09253 1.23633L11.9696 4.7348L18.8466 1.23633L17.6445 8.85787L23.0969 14.3172L15.4769 15.5291L11.9696 22.4017L8.94015 16.4655L4.48913 22.4001L2.88914 21.2001L7.28309 15.3416L0.842285 14.3172L6.29466 8.85787L5.09253 1.23633Z" fill="currentColor"/></CentralIconBase>;
});

export default IconStarWand;
